import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { signIn, useSession } from 'next-auth/react';
import { useEffect } from 'react';

import MainLoader from '../../components/Loader';
import backendService from '../../services/backendService';

const AuthenticatedJoin = () => {
  const router = useRouter();

  const invitationCode = router.query.invitationCode as string;

  const { data, isFetching } = useQuery(['join'], () =>
    backendService.instance.joinTenant(invitationCode),
  );

  useEffect(() => {
    if (data) {
      router.push(`/${data.tenantId}`);
    }
  }, [data, router]);
  return <>{isFetching && <MainLoader />}</>;
};
const UnAuthenticatedJoin = () => {
  const router = useRouter();

  const invitationCode = router.query.invitationCode as string;

  useEffect(() => {
    signIn(
      'azure-ad-b2c-join',
      { callbackUrl: '/' },
      { ui_locales: 'en', invitationCode },
    );
  }, [invitationCode]);
  return <MainLoader />;
};

const JoinPage = () => {
  const session = useSession();

  if (!session || session.status === 'loading') {
    return <MainLoader />;
  }

  if (session && session.status === 'authenticated') {
    return <AuthenticatedJoin />;
  }
  if (session && session.status === 'unauthenticated') {
    return <UnAuthenticatedJoin />;
  }

  return null;
};

export default JoinPage;
